<template>
  <section>
    <el-tag type="warning" class="mb-3">Work in Progress</el-tag>

    <el-table :data="tableData" border>
      <!-- <el-table-column type="expand">
        <template slot-scope="props">
          <p>State: ...</p>
          <p>City: ...</p>
          <p>Address: ...</p>
          <p>Zip: ...</p>
        </template>
      </el-table-column> -->
      <el-table-column label="ID" width="180">
        <template slot-scope="scope">
          <i class="el-icon-document"></i>
          <span style="margin-left: 10px">{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="user" label="User"></el-table-column>
      <el-table-column prop="started" label="Started"></el-table-column>
      <el-table-column prop="stopped" label="Stopped"></el-table-column>
      <el-table-column prop="summary" label="Summary">
        <!-- <template slot-scope="scope">
          <div class="tag-group">
            <el-tag type="success">{{ scope.row.summary.leads }} Leads</el-tag>
            <el-tag type="success">{{ scope.row.summary.brokers }} Brokers</el-tag>
            <el-tag type="success">{{ scope.row.summary.tenants }} Tenants</el-tag>
          </div>
        </template> -->
      </el-table-column>

      <!-- <el-table-column v-for="(e, i) in tableData[0]" :prop="i" :label="i | capitalise"></el-table-column> -->
    </el-table>
  </section>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      tableData: [
        {
          id: 3,
          user: "Emma Cielo",
          started: "01/11/2021 08:00 AM",
          stopped: "01/11/2021 06:00 PM",
          summary: "136 leads assigned"
        },
        {
          id: 2,
          user: "Gene Estreich",
          started: "28/10/2021 12:00 PM",
          stopped: "29/10/2021 12:00 PM",
          summary: "203 leads assigned"
        },
        {
          id: 1,
          user: "Gene Estreich",
          started: "28/10/2021 10:00 AM",
          stopped: "28/10/2021 11:00 AM",
          summary: "30 leads assigned"
        }
      ]
    }
  },
  computed: {},
  watch: {},
  mounted() {},
  updated() {},
  activated() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
// @import '@assets/sass/backend/_core-variables.scss';
</style>
